import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import * as autoThunks from 'features/auto-thunks'
import ApprovedSeries from './approved-series-model'
import {
  CreateApprovedSeriesAsync,
  DeleteApprovedSeriesAsync,
  LoadApprovedSeriessAsync,
} from './approvedSeries-thunk'
const initialState: approvedSeriesSliceState = {
  approvedSeries: [],
  selected_approvedSeries: '',
  is_loading_approvedSeries: false,
  is_creating_approvedSeries: false,
  is_deleting_approvedSeries: false,
}
export interface approvedSeriesSliceState {
  approvedSeries: ApprovedSeries[]
  selected_approvedSeries?: string
  is_loading_approvedSeries: boolean
  is_creating_approvedSeries: boolean
  is_deleting_approvedSeries: boolean
}
export const approvedSeriesSlice = createSlice({
  name: 'approvedSeries',
  initialState,
  reducers: {
    setSelectedapprovedSeries: (state, action) => {
      state.selected_approvedSeries = action.payload
    },
    clearStateapprovedSeries: (state) => {
      state.approvedSeries = []
      state.is_loading_approvedSeries = false
      state.is_creating_approvedSeries = false
      state.is_deleting_approvedSeries = false
    },
    mergeapprovedSeries: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_approvedSeries = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.approvedSeries = merge(state.approvedSeries, payload) as any
        }
      }
    },

    add_approvedSeries: (state, action) => {
      if (action.payload) {
        state.approvedSeries = [...state.approvedSeries, action.payload]
      }
    },
    set_approvedSeries: (state, action) => {
      let { key, value, id } = action.payload
      state.approvedSeries = state.approvedSeries.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadApprovedSeriessAsync.pending, (state) => {
      state.is_loading_approvedSeries = true
    })
    builder.addCase(LoadApprovedSeriessAsync.fulfilled, (state, action) => {
      state.is_loading_approvedSeries = false
      if (action.payload) {
        state.approvedSeries = action.payload
      }
    })
    builder.addCase(LoadApprovedSeriessAsync.rejected, (state) => {
      state.is_loading_approvedSeries = false
    })
    builder.addCase(CreateApprovedSeriesAsync.pending, (state) => {
      state.is_creating_approvedSeries = true
    })
    builder.addCase(CreateApprovedSeriesAsync.fulfilled, (state) => {
      state.is_creating_approvedSeries = false
    })
    builder.addCase(CreateApprovedSeriesAsync.rejected, (state) => {
      state.is_creating_approvedSeries = false
    })
    builder.addCase(DeleteApprovedSeriesAsync.pending, (state) => {
      state.is_deleting_approvedSeries = true
    })
    builder.addCase(DeleteApprovedSeriesAsync.fulfilled, (state, action) => {
      state.is_deleting_approvedSeries = false
      if (state.approvedSeries) {
        state.approvedSeries = state.approvedSeries.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteApprovedSeriesAsync.rejected, (state) => {
      state.is_deleting_approvedSeries = false
    })

    builder.addCase(autoThunks.get_series_for_user.pending, (state) => {
      state.is_loading_approvedSeries = true
    })
    builder.addCase(
      autoThunks.get_series_for_user.fulfilled,
      (state, action) => {
        state.is_loading_approvedSeries = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.get_series_for_user.rejected, (state) => {
      state.is_loading_approvedSeries = false
    })

    builder.addCase(
      autoThunks.get_approved_series_by_series_id.pending,
      (state) => {
        state.is_loading_approvedSeries = true
      },
    )
    builder.addCase(
      autoThunks.get_approved_series_by_series_id.fulfilled,
      (state, action) => {
        state.is_loading_approvedSeries = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.get_approved_series_by_series_id.rejected,
      (state) => {
        state.is_loading_approvedSeries = false
      },
    )

    builder.addCase(
      autoThunks.get_approved_series_by_highlightseries_id.pending,
      (state) => {
        state.is_loading_approvedSeries = true
      },
    )
    builder.addCase(
      autoThunks.get_approved_series_by_highlightseries_id.fulfilled,
      (state, action) => {
        state.is_loading_approvedSeries = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.get_approved_series_by_highlightseries_id.rejected,
      (state) => {
        state.is_loading_approvedSeries = false
      },
    )

    builder.addCase(autoThunks.load_approved_series.pending, (state) => {
      state.is_loading_approvedSeries = true
    })
    builder.addCase(
      autoThunks.load_approved_series.fulfilled,
      (state, action) => {
        state.is_loading_approvedSeries = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.load_approved_series.rejected, (state) => {
      state.is_loading_approvedSeries = false
    })

    builder.addCase(
      autoThunks.get_approved_series_by_series_id_watch.pending,
      (state) => {
        state.is_loading_approvedSeries = true
      },
    )
    builder.addCase(
      autoThunks.get_approved_series_by_series_id_watch.fulfilled,
      (state, action) => {
        state.is_loading_approvedSeries = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.get_approved_series_by_series_id_watch.rejected,
      (state) => {
        state.is_loading_approvedSeries = false
      },
    )

    builder.addCase(autoThunks.get_approved_series.pending, (state) => {
      state.is_loading_approvedSeries = true
    })
    builder.addCase(
      autoThunks.get_approved_series.fulfilled,
      (state, action) => {
        state.is_loading_approvedSeries = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.get_approved_series.rejected, (state) => {
      state.is_loading_approvedSeries = false
    })
  },
})

function handleResult(action: any, state: approvedSeriesSliceState) {
  if (action.payload) {
    let payload: any = action.payload
    if (payload?.data) {
      if (!Array.isArray(payload.data)) {
        state.selected_approvedSeries = payload?.data?.id
        payload = [payload.data]
      } else {
        payload = payload.data
      }
      state.approvedSeries = merge(state.approvedSeries, payload) as any
    }
  }
}

export const {
  clearStateapprovedSeries,
  setSelectedapprovedSeries,
  set_approvedSeries,
  mergeapprovedSeries,
  add_approvedSeries,
} = approvedSeriesSlice.actions

export const get_approvedSeries =
  (id?: string) =>
  (state: {
    approvedSeries: {
      approvedSeries: ApprovedSeries[]
    }
  }): ApprovedSeries | null => {
    let temp = state?.approvedSeries?.approvedSeries?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.approvedSeries?.approvedSeries[0] || null
  }
export const get_selected_approvedSeries = (state: {
  approvedSeries: approvedSeriesSliceState
}): ApprovedSeries | null => {
  let id = state?.approvedSeries?.selected_approvedSeries
  let temp = state?.approvedSeries?.approvedSeries?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_approvedSeries = (state: {
  approvedSeries: {
    approvedSeries: ApprovedSeries[]
  }
}): ApprovedSeries[] => {
  let temp = state?.approvedSeries?.approvedSeries
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_approvedSeries_busy = (state: {
  approvedSeries: approvedSeriesSliceState
}) => {
  return (
    state?.approvedSeries.is_deleting_approvedSeries ||
    state?.approvedSeries.is_loading_approvedSeries ||
    state?.approvedSeries.is_creating_approvedSeries
  )
}
export const is_deleting_approvedSeries_busy = (state: {
  approvedSeries: approvedSeriesSliceState
}) => {
  return state?.approvedSeries.is_deleting_approvedSeries
}
export const is_loading_approvedSeries_busy = (state: {
  approvedSeries: approvedSeriesSliceState
}) => {
  return state?.approvedSeries.is_loading_approvedSeries
}
export const is_creating_approvedSeries_busy = (state: {
  approvedSeries: approvedSeriesSliceState
}) => {
  return state?.approvedSeries.is_creating_approvedSeries
}

export default approvedSeriesSlice.reducer
